import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react';
import { Modal } from 'rsuite';

import { SESSION_STORAGE_DISABLED_IA, TRUE_STRING } from '@/common/constants';
import { useMiniCartContext } from '@/common/contexts/MiniCartContext/MiniCartContext';
import {
  ChildrenDefaultProps,
  ChildrenPropTypes,
} from '@/common/proptypes/Base/Children.proptypes';
import IA from '@/ebat/components/blocks/Modal/Common/IA/IA';

const ModalIAContext = createContext(null);

export const ModalIAContextProvider = ({ children }) => {
  const [isDisabledIA, setIsDisabledIA] = useState(
    sessionStorage.getItem(SESSION_STORAGE_DISABLED_IA) === TRUE_STRING,
  );
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [addedItem, setAddedItem] = useState();
  const [modalContent, setModalContent] = useState();
  const { setIsVisible } = useMiniCartContext();

  const handleDisableIA = () => {
    sessionStorage.setItem(SESSION_STORAGE_DISABLED_IA, true);

    setIsDisabledIA(true);
    setModalIsOpen(false);
  };

  useEffect(() => {
    if (modalIsOpen) {
      setIsVisible(false);
    }
  }, [modalIsOpen, setIsVisible]);

  const onOpenModal = useCallback(() => setModalIsOpen(true), []);

  const onCloseModal = useCallback(() => setModalIsOpen(false), []);

  return (
    <ModalIAContext.Provider
      value={{
        handleDisableIA,
        isDisabledIA,
        modalIsOpen,
        onCloseModal,
        onOpenModal,
        setAddedItem,
        setModalContent,
        setModalIsOpen,
      }}
    >
      {children}
      <Modal
        className="modal-ia"
        open={modalIsOpen}
        overflow={false}
        onClose={onCloseModal}
      >
        <Modal.Header />
        <Modal.Body>
          <IA closeModal={onCloseModal} item={addedItem}>
            {modalContent}
          </IA>
        </Modal.Body>
      </Modal>
    </ModalIAContext.Provider>
  );
};

export const useModalIAContext = () => useContext(ModalIAContext);

ModalIAContextProvider.defaultProps = {
  ...ChildrenDefaultProps,
};

ModalIAContextProvider.propTypes = {
  ...ChildrenPropTypes,
};
